// GA4 Event Tracking Utility

// Check if gtag is available
const isGtagAvailable = () => {
  return typeof window !== 'undefined' && window.gtag;
};

// Track GA4 event
export const trackGA4Event = (eventName, parameters = {}) => {
  if (isGtagAvailable()) {
    window.gtag('event', eventName, parameters);
  }
};

// Account Setup specific tracking events
export const trackAccountSetupEvent = {
  // Performance bond tracking
  performanceBondSent: (accountId, amount, sentDate, userEmail = null) => {
    trackGA4Event('performance_bond_sent', {
      account_id: accountId,
      bond_amount: amount,
      sent_date: sentDate,
      user_email: userEmail,
      timestamp: new Date().toISOString()
    });
  },

  // Congratulations modal OK button click
  congratulationsModalOK: (accountId, userEmail = null) => {
    trackGA4Event('congratulations_modal_ok_clicked', {
      account_id: accountId,
      user_email: userEmail,
      timestamp: new Date().toISOString()
    });
  }
};

export default trackAccountSetupEvent; 